import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";
import {
  localeDateEndDate,
  localeDateStartDate,
} from "../constants/DateUtil/DateUtil";
import AdminMenu from "./AdminMenu";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dropdown } from "primereact/dropdown";
import { getNewStoreCustomers } from "../services/CustomerInfo/CustomerInfo";
import { getBrandStore } from "../services/StoreUsers/PostStoreUsers";

const InactiveCustomer = () => {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();
  const brandId = brandProfileData?.id;

  const [newCustomerData, setNewCustomerData] = useState("");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [brandStoreData, setBrandStoreData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");

  useEffect(() => {
    if (!brandId) return;

    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const stores = response.data || [];
          setBrandStoreData(stores);
          if (stores.length === 1) {
            setSelectedStoreId(stores[0].id);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching stores:", err);
      });
  }, [brandId]);

  const fetchNewStoreCustomers = useCallback(
    (data) => {
      setLoading(true);
      getNewStoreCustomers(data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            setNewCustomerData(Res);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        })
        .finally(() => setLoading(false));
    },
    [setNewCustomerData],
  );

  useEffect(() => {
    if (!brandId || !selectedStoreId) return;

    const today = new Date();

    const data = {
      storeIdIn: [selectedStoreId],
      brandId: brandId,
      startDate: localeDateStartDate(today),
      endDate: localeDateEndDate(today),
    };

    fetchNewStoreCustomers(data);
  }, [fetchNewStoreCustomers, selectedStoreId, brandId]);

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Customers")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                New Customer
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-4">
        <div className="flex flex-wrap align-items-center gap-3 mb-3">
          <div style={{ flex: "1 1 0", minWidth: 220 }}>
            <label className="block text-md font-bold mb-2 text-900">
              Store
            </label>
            <Dropdown
              value={selectedStoreId}
              options={brandStoreData.map((store) => ({
                label: store.storeName,
                value: store.id,
              }))}
              onChange={(e) => setSelectedStoreId(e.value)}
              placeholder="Select store"
              className="w-full"
              showClear={false}
            />
          </div>

        </div>

         

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : selectedStoreId && newCustomerData > 0 ? (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">
              {newCustomerData} New customers found
            </p>
          </div>
        ) : selectedStoreId ? (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">
              No new customers found for today.
            </p>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">
              Select a store to view new customers.
            </p>
          </div>
        )}
      </div>
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default InactiveCustomer;
